// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `main {
  font-family: var(--tertiary-font);
  position: relative;
}

.PublicCatalogue_pch__qA8JQ {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 2rem;
  padding: 2rem 0;
  align-items: center;
  position: sticky;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100%;
  background-color: var(--color-white);
  border-bottom: 1px solid var(--color-grey);
}

.PublicCatalogue_gtmw__jyziO {
  padding: 2rem;
  border-radius: 2rem;
  font-size: 1.8rem;
  background-color: var(--color-dark);
  font-weight: 600;
  cursor: pointer;
  color: var(--color-white);
  margin-left: 5rem;
}
.PublicCatalogue_gtmw__jyziO:hover {
  background-color: var(--color-grey);
  color: var(--color-dark);
}
@media only screen and (max-width: 31.25em) {
  .PublicCatalogue_gtmw__jyziO {
    margin-left: 3rem;
  }
}

.PublicCatalogue_pcb__eiPGI {
  margin-top: 5rem;
  padding: 0 20rem 5rem;
}
@media only screen and (max-width: 75em) {
  .PublicCatalogue_pcb__eiPGI {
    padding: 0 15rem 5rem;
  }
}
@media only screen and (max-width: 56.25em) {
  .PublicCatalogue_pcb__eiPGI {
    padding: 0 10rem 5rem;
  }
}
@media only screen and (max-width: 37.5em) {
  .PublicCatalogue_pcb__eiPGI {
    padding: 0 5rem 5rem;
  }
}
@media only screen and (max-width: 31.25em) {
  .PublicCatalogue_pcb__eiPGI {
    padding: 0 3rem 5rem;
  }
}

.PublicCatalogue_spc__IdwTk {
  margin-top: 5rem;
  padding: 0 15rem 5rem;
}
@media only screen and (max-width: 56.25em) {
  .PublicCatalogue_spc__IdwTk {
    padding: 0 10rem 5rem;
  }
}
@media only screen and (max-width: 37.5em) {
  .PublicCatalogue_spc__IdwTk {
    padding: 0 5rem 5rem;
  }
}
@media only screen and (max-width: 31.25em) {
  .PublicCatalogue_spc__IdwTk {
    padding: 0 3rem 5rem;
  }
}
.PublicCatalogue_spc__content__tsUPl {
  display: grid;
  grid-template-columns: minmax(auto, 50%) 1fr;
  border-radius: 5rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
}
@media only screen and (max-width: 50em) {
  .PublicCatalogue_spc__content__tsUPl {
    grid-template-columns: 100%;
  }
}
.PublicCatalogue_spc__content__tsUPl > :first-child img {
  border-radius: 5rem 0 0 5rem;
  width: 100%;
}
@media only screen and (max-width: 50em) {
  .PublicCatalogue_spc__content__tsUPl > :first-child img {
    border-radius: 5rem 5rem 0 0;
  }
}
.PublicCatalogue_spc__content__tsUPl > :last-child {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 3rem;
}

.PublicCatalogue_pcback__moxub {
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-top: 3rem;
  padding: 0 15rem;
  font-size: 2.4rem;
  cursor: pointer;
}
.PublicCatalogue_pcback__moxub:hover {
  color: var(--color-primary-4);
}
.PublicCatalogue_pcback__moxub > :first-child {
  font-size: 5rem;
}
@media only screen and (max-width: 56.25em) {
  .PublicCatalogue_pcback__moxub {
    padding: 0 10rem;
  }
}
@media only screen and (max-width: 37.5em) {
  .PublicCatalogue_pcback__moxub {
    padding: 0 5rem;
  }
}
@media only screen and (max-width: 31.25em) {
  .PublicCatalogue_pcback__moxub {
    padding: 0 3rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/PublicCatalogue/PublicCatalogue.module.scss"],"names":[],"mappings":"AAEA;EACI,iCAAA;EACA,kBAAA;AADJ;;AAIA;EACI,aAAA;EACA,sCAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,oCAAA;EACA,0CAAA;AADJ;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mCAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;AADJ;AAGI;EACI,mCAAA;EACA,wBAAA;AADR;AAII;EAfJ;IAgBQ,iBAAA;EADN;AACF;;AAIA;EACI,gBAAA;EACA,qBAAA;AADJ;AAGI;EAJJ;IAKQ,qBAAA;EAAN;AACF;AAEI;EARJ;IASQ,qBAAA;EACN;AACF;AACI;EAZJ;IAaQ,oBAAA;EAEN;AACF;AAAI;EAhBJ;IAiBQ,oBAAA;EAGN;AACF;;AAAA;EACI,gBAAA;EACA,qBAAA;AAGJ;AADI;EAJJ;IAKQ,qBAAA;EAIN;AACF;AAFI;EARJ;IASQ,oBAAA;EAKN;AACF;AAHI;EAZJ;IAaQ,oBAAA;EAMN;AACF;AAJI;EACI,aAAA;EACA,4CAAA;EACA,mBAAA;EACA,4CAAA;AAMR;AAJQ;EANJ;IAOQ,2BAAA;EAOV;AACF;AAJY;EACI,4BAAA;EACA,WAAA;AAMhB;AAJgB;EAJJ;IAKQ,4BAAA;EAOlB;AACF;AAFQ;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;AAIZ;;AACA;EACI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAEJ;AAAI;EACI,6BAAA;AAER;AACI;EACI,eAAA;AACR;AAGI;EAlBJ;IAmBQ,gBAAA;EAAN;AACF;AAEI;EAtBJ;IAuBQ,eAAA;EACN;AACF;AACI;EA1BJ;IA2BQ,eAAA;EAEN;AACF","sourcesContent":["@import '../variables/breakpoints';\n\nmain {\n    font-family: var(--tertiary-font);\n    position: relative;\n}\n\n.pch {\n    display: grid;\n    grid-template-columns: max-content 1fr;\n    gap: 2rem;\n    padding: 2rem 0;\n    align-items: center;\n    position: sticky;\n    z-index: 100;\n    top: 0;\n    left: 0;\n    width: 100%;\n    background-color: var(--color-white);\n    border-bottom: 1px solid var(--color-grey);\n}\n\n.gtmw {\n    padding: 2rem;\n    border-radius: 2rem;\n    font-size: 1.8rem;\n    background-color: var(--color-dark);\n    font-weight: 600;\n    cursor: pointer;\n    color: var(--color-white);\n    margin-left: 5rem;\n\n    &:hover {\n        background-color: var(--color-grey);\n        color: var(--color-dark);\n    }\n\n    @media only screen and (max-width: $bp-500) {\n        margin-left: 3rem;\n    }\n}\n\n.pcb {\n    margin-top: 5rem;\n    padding: 0 20rem 5rem;\n\n    @media only screen and (max-width: $bp-1200) {\n        padding: 0 15rem 5rem;\n    }\n\n    @media only screen and (max-width: $bp-900) {\n        padding: 0 10rem 5rem;\n    }\n\n    @media only screen and (max-width: $bp-600) {\n        padding: 0 5rem 5rem;\n    }\n\n    @media only screen and (max-width: $bp-500) {\n        padding: 0 3rem 5rem;\n    }\n}\n\n.spc {\n    margin-top: 5rem;\n    padding: 0 15rem 5rem;\n\n    @media only screen and (max-width: $bp-900) {\n        padding: 0 10rem 5rem;\n    }\n\n    @media only screen and (max-width: $bp-600) {\n        padding: 0 5rem 5rem;\n    }\n\n    @media only screen and (max-width: $bp-500) {\n        padding: 0 3rem 5rem;\n    }\n\n    &__content {\n        display: grid;\n        grid-template-columns: minmax(auto, 50%) 1fr;\n        border-radius: 5rem;\n        box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\n        @media only screen and (max-width: $bp-800) {\n            grid-template-columns: 100%;\n        }\n\n        &> :first-child {\n            img {\n                border-radius: 5rem 0 0 5rem;\n                width: 100%;\n\n                @media only screen and (max-width: $bp-800) {\n                    border-radius: 5rem 5rem 0 0;\n\n                }\n            }\n        }\n\n        &> :last-child {\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            padding: 3rem\n        }\n    }\n}\n\n.pcback {\n    display: flex;\n    gap: 1rem;\n    align-items: center;\n    margin-top: 3rem;\n    padding: 0 15rem;\n    font-size: 2.4rem;\n    cursor: pointer;\n\n    &:hover {\n        color: var(--color-primary-4);\n    }\n\n    &> :first-child {\n        font-size: 5rem;\n\n    }\n\n    @media only screen and (max-width: $bp-900) {\n        padding: 0 10rem;\n    }\n\n    @media only screen and (max-width: $bp-600) {\n        padding: 0 5rem;\n    }\n\n    @media only screen and (max-width: $bp-500) {\n        padding: 0 3rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pch": `PublicCatalogue_pch__qA8JQ`,
	"gtmw": `PublicCatalogue_gtmw__jyziO`,
	"pcb": `PublicCatalogue_pcb__eiPGI`,
	"spc": `PublicCatalogue_spc__IdwTk`,
	"spc__content": `PublicCatalogue_spc__content__tsUPl`,
	"pcback": `PublicCatalogue_pcback__moxub`
};
export default ___CSS_LOADER_EXPORT___;
